import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
import PrimerErrorDescription from './onCheckoutFail_error';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Group = makeShortcode("Group");
const Item = makeShortcode("Item");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`Called after a customer submitted their payment data and the payment details could not be tokenized.
Use the `}<inlineCode parentName="p">{`PrimerClientError`}</inlineCode>{` data to display an error message.`}</p>
    <Group summary="Parameters" mdxType="Group">
      <Item title="error" subtitle="PrimerError" mdxType="Item">
        <Group summary="Properties" mdxType="Group">
          <PrimerErrorDescription mdxType="PrimerErrorDescription" />
        </Group>
      </Item>
    </Group>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      